<template>
<div>

<h2 id="contact">Contact</h2>

        <!-- Fin de formulaire -->
        <section class="wrapperContact">
            <div alt="LinkedIn" class="Linkedin"><i class="fab fa-linkedin"></i></div>
            <div alt="Téléphone" class="Telephone">
                    <i class="fas fa-phone-volume"></i></div>
            <div alt="QrCode" class="QrCode"><i class="fas fa-qrcode"></i><br /><strong>V-Card</strong></div>
            <div class="LienLinkedin lienL"><a href="https://www.linkedin.com/in/emmanuel-trepant/" target="_self">Envoyez
                    moi <br />un message (via LinkedIn)</a></div>
            <div class="TelephoneNumber"><strong>Mon numéro de téléphone</strong><br />02.733.62.36</div>
            <div class="ImageQrCode"><img class="qr" src="../../public/img/qr-code.png" alt="Mes informations"></div>
        </section>

</div>
</template>

<script>
export default 

{
        name: 'contactV',
        data() { 

        return    {

                lienContact : [
                {
                lien : "https://www.linkedin.com/in/emmanuel-trepant/",
                picto : "fab fa-linkedin",
                altTexte : "LinkedIn",
                texte : "Envoyez moi un message (LinkedIn)"
                },
                {
                lien : "https://www.linkedin.com/in/emmanuel-trepant/",
                picto : "fas fa-phone-volume",
                altTexte : "Téléphone",
                texte : "Mon numéro de téléphone 02.733.62.36"
                },
                {
                lien : "www.vcard",
                picto : "assets/images/qr-code.png",
                altTexte : "Téléphone",
                texte : "Mes informations"
                }
                ]
                        }
        },

};

</script>

<style scoped>
        .champsBouton{
        text-align: center;
        }

        .champsBouton button{
        padding:10px 40px;
        border: 1px solid #E7E7E7;
        background-color: #306ea3;
        color:white;
        border-radius: 4px;
        }

/* Zone form email */

        .wrapperEmail {
        display: grid;
        border: 1px solid #E7E7E7;
        background-color: #FAFAFA;
        box-shadow: 5px 5px 5px rgba(0,0,0,0.1);
        border-radius: 4px;
        padding: 40px 100px 40px 100px;
        margin: 0 40px 40px 40px;
        grid-gap: 2rem;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
        "champsEmail  champsEmail"
        "champsEmail  champsBouton"
        ;
        }

        .champsEmail label {
        display: block;
        font-family: "Lato", sans-serif;
        padding: 10px 10px 10px 0;
        font-size: 12px;
        text-align: left;
        }

        input, select, textarea{
        color: #306ea3;
        border: 1px solid #E7E7E7;
        font-size: 14px;
        padding: 10px;
        width: 100%;
        }

        /* Couleur à l'intérieur des champs */
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #306ea3;
        opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #306ea3;
        }

        ::-ms-input-placeholder { /* Microsoft Edge */
        color: #306ea3;
        }

        /* empêcher redimension text-area */
        textarea[name=message]
        {
        resize : both;
        min-width : 100%;
        min-height : 100px;
        max-width : 200px;
        max-height : 200px;
        }

        /* input Pot de Miel */
        .potDeMiel{display:none;
        }

        .wrapperContact {
        color: #306ea3;
        margin: 0 120px 0 120px;
        display: grid;
        text-align: center;
        vertical-align: middle;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-areas:
        "Linkedin  Telephone  QrCode"
        "LienLinkedin  TelephoneNumber  ImageQrCode";
        }

        .qr {
        width: 100px;
        height: auto;
        }

        .Linkedin,
        .Telephone,
        .QrCode {
        padding: 10px;
        color: #306ea3;
        }

        .LienLinkedin a {
        color: #306ea3;
        padding: 5px;
        }

        div.LienLinkedin.lienL a{     
        background-color: white;
        }

        div.LienLinkedin.lienL a:hover{     
        text-decoration: underline;
        }


        .fab,
        .fas {
        text-align: center;
        font-size: 40px;
        color: #306ea3;
        }


/* --------------------------------- 800px  */
@media only screen and (max-width: 800px) {

       .wrapperContact {
        margin: 0 20px 0 20px;
        }

        input, select, textarea{
        display: block;
        width: 100%;
        }

        /* form zone email  */
        .wrapperEmail {
        text-align: center;
        padding: 40px 100px 40px 100px;
        margin: 0 40px 40px 40px;
        display: grid;
        grid-gap: 2rem;
        grid-template-columns: 1fr;
        grid-template-areas:
        "champsEmail"
        "champsEmail"
        "champsEmail"
        "champsBouton";
        }
}


/* --------------------------------- 640 px  */
@media only screen and (max-width: 640px) {

        input, select, textarea{
        display: block;
        width: 100%;
        }

        /* form zone email  */
        .wrapperEmail {
        display: grid;
        grid-gap: 2rem;
        grid-template-columns: 1fr;
        grid-template-areas:
        "champsEmail"
        "champsEmail"
        "champsEmail"
        "champsBouton"
        ;
        }

        .Linkedin,
        .LienLinkedin,
        .Telephone,
        .TelephoneNumber,
        .QrCode,
        .ImageQrCode {
        border-bottom: 1px solid rgb(241, 238, 238);
        color: #306ea3;
        }

        .wrapperContact {
        display: grid;
        grid-gap: 2rem;
        grid-template-columns: 60px 1fr;
        }


        .Telephone {
        grid-area: 2 / 1 / span 1 / span 1;
        }

        .TelephoneNumber {
        grid-area: 2 / 2 / span 1 / span 1;
        }

        .QrCode {
        grid-area: 3 / 1 / span 1 / span 1;
        border-bottom: none;
        }

        .ImageQrCode {
        grid-area: 3 / 2 / span 1 / span 1;
        border-bottom: none;
        } 
}

</style>



